document.addEventListener('DOMContentLoaded', function () {
  //Select field dropdown arrow on fluent forms
  var selectElements = document.querySelectorAll("select");

  if (selectElements) {
    selectElements.forEach(function (selectElement) {
      if (selectElement.parentElement.classList.contains("ff-el-input--content")) {
        selectElement.parentElement.classList.add("relative");
        selectElement.parentElement.innerHTML += "<i class='icon-caret-down absolute text-black'></i>";
      }
    });
  } //adding wrapper around tables to style nicer responsively


  var tables = document.querySelectorAll("table");

  if (tables) {
    tables.forEach(function (table) {
      var tableForm = table.closest("form");
      if (table.classList.contains("shop_table") || table.classList.contains("variations") || tableForm && tableForm.hasAttribute('id') && tableForm.id == "cc-settings") return;
      var tableContainer = document.createElement("div");
      table.parentNode.insertBefore(tableContainer, table);
      tableContainer.appendChild(table);
      tableContainer.classList.add("w-full", "overflow-x-auto");
    });
  }
});
jQuery(document).ready(function ($) {
  //Add class to selected Checkboxes
  $('.gfield_checkbox li input[type="checkbox"]').change(function () {
    if ($(this).is(':checked')) {
      $(this).parent().addClass('is-checked');
    } else {
      $(this).parent().removeClass('is-checked');
    }
  });
});